import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { url, path, filename }
}

export async function uploadSoftwareChunked(file, onProgress) {
  const raw = (window.crypto && window.crypto.randomUUID)
    ? window.crypto.randomUUID()
    : `up-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const uploadId = raw.replace(/[^A-Za-z0-9_-]/g, "").slice(0, 60) || `up${Date.now()}`;
  const CHUNK = 5 * 1024 * 1024;
  const total = file.size;
  const count = Math.max(1, Math.ceil(total / CHUNK));
  let sent = 0;
  for (let i = 0; i < count; i++) {
    const blob = file.slice(i * CHUNK, Math.min((i + 1) * CHUNK, total));
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", String(i));
    fd.append("file", blob, file.name);
    await api.post("/custom-software/upload/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
    sent += blob.size;
    if (onProgress) onProgress(Math.min(99, Math.round((sent / total) * 100)));
  }
  const { data } = await api.post("/custom-software/upload/finalize", { upload_id: uploadId, filename: file.name });
  if (onProgress) onProgress(100);
  return data; // { url, path, filename, ext }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
